export default __webpack_public_path__ + "static/media/rails.2ac22bc0.svg";